// src/pages/Upload.jsx

import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Paper
} from '@mui/material';

export default function Upload() {
  const [selectedDate, setSelectedDate] = useState('');
  const [file, setFile]                 = useState(null);
  const [error, setError]               = useState('');
  const [success, setSuccess]           = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!selectedDate || !file) {
      setError('Please pick a date and CSV file.');
      return;
    }

    const formData = new FormData();
    formData.append('upload_date', selectedDate);
    formData.append('source_file', file);

    try {
      const res = await axios.post('/api/uploads/', formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setSuccess(`Uploaded for ${res.data.date}`);
      setFile(null);
    } catch (err) {
      console.error('Upload error payload:', err.response?.data);
      if (err.response?.data?.errors) {
        setError(JSON.stringify(err.response.data.errors));
      } else {
        setError('Upload failed. See console for details.');
      }
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        CSV Upload
      </Typography>

      <Paper sx={{ p:3, maxWidth:400 }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}

          <TextField
            label="Upload Date"
            type="date"
            value={selectedDate}
            onChange={e => setSelectedDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <Button
            variant="contained"
            component="label"
          >
            {file ? file.name : 'Select CSV File'}
            <input
              type="file"
              accept=".csv"
              hidden
              onChange={e => setFile(e.target.files[0] || null)}
            />
          </Button>

          <Button
            type="submit"
            variant="contained"
            disabled={!selectedDate || !file}
          >
            Upload
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
